export const messages = {
  en: {
    ownerCommitteeDetail: {
      title: 'Owner Committee Detail',
      name: 'Name',
      sex: 'Gender',
      link: 'Phone',
      idCard: 'ID Card',
      address: 'Address',
      position: 'Position',
      post: 'Post',
      postDesc: 'Post Description',
      appointTime: 'Appointment Period',
      curTime: 'Term of Office',
      state: 'Status',
      remark: 'Remark',
      emergencyContacts: 'Emergency Contacts',
      memberRelation: 'Member Relation',
      contactPhone: 'Contact Phone',
      fetchDetailError: 'Failed to fetch committee details',
      fetchContactsError: 'Failed to fetch emergency contacts'
    }
  },
  zh: {
    ownerCommitteeDetail: {
      title: '业委会成员详情',
      name: '姓名',
      sex: '性别',
      link: '电话',
      idCard: '身份证号码',
      address: '住址',
      position: '职位',
      post: '岗位',
      postDesc: '岗位描述',
      appointTime: '届期',
      curTime: '任期',
      state: '状态',
      remark: '备注',
      emergencyContacts: '紧急联系人',
      memberRelation: '成员关系',
      contactPhone: '联系电话',
      fetchDetailError: '获取业委会详情失败',
fetchContactsError: '获取紧急联系人失败'
    }
  },
  'zh-TW': {
    ownerCommitteeDetail: {
      title: '業委會成員詳情',
      name: '姓名',
      sex: '性別',
      link: '電話',
      idCard: '身份證號碼',
      address: '住址',
      position: '職位',
      post: '崗位',
      postDesc: '崗位描述',
      appointTime: '屆期',
      curTime: '任期',
      state: '狀態',
      remark: '備註',
      emergencyContacts: '緊急聯繫人',
      memberRelation: '成員關係',
      contactPhone: '聯繫電話',
      fetchDetailError: '獲取業委會詳情失敗',
      fetchContactsError: '獲取緊急聯繫人失敗'
    }
  }
}